/**
 * PhysicsSystem - Initializes Cannon.js physics through Babylon's physics engine.
 * Configured for realistic football physics with proper timestep.
 */

import * as BABYLON from "babylonjs";

export class PhysicsSystem {
  constructor(scene: BABYLON.Scene) {
    const gravity = new BABYLON.Vector3(0, -9.81, 0);
    
    // Ensure CANNON is available globally before creating plugin
    if (!(window as any).CANNON) {
      console.error("CANNON.js not loaded! Make sure it's imported in main.ts");
      return;
    }
    
    const plugin = new BABYLON.CannonJSPlugin(true, 10);
    
    // Enable physics
    scene.enablePhysics(gravity, plugin);
    
    // Wait a tick for physics to initialize
    setTimeout(() => {
      const physEngine = scene.getPhysicsEngine();
      if (physEngine) {
        physEngine.setSubTimeStep(2); // Reduced from 5 for better performance
        console.log("Physics system initialized");
      }
    }, 0);
  }

  /** Create a sphere impostor with Cannon.js native damping for realistic rolling */
  static sphereImpostor(
    mesh: BABYLON.Mesh,
    mass: number,
    restitution = 0.6,
    friction = 0.5 // Increased for better roll on grass via engine
  ): void {
    mesh.physicsImpostor = new BABYLON.PhysicsImpostor(
      mesh,
      BABYLON.PhysicsImpostor.SphereImpostor,
      { mass, restitution, friction },
      mesh.getScene()
    );

    const body = mesh.physicsImpostor.physicsBody;
    if (body) {
      // Natural rolling resistance via engine damping
      body.linearDamping = 0.15;
      body.angularDamping = 0.15;

      // Continuous collision detection — prevents tunneling through thin walls
      body.ccdSpeedThreshold = 1;
      body.ccdSweptSphereRadius = 0.2;
    }
  }

  static boxImpostor(
    mesh: BABYLON.Mesh,
    mass: number,
    restitution = 0.3,
    friction = 0.8
  ): void {
    mesh.physicsImpostor = new BABYLON.PhysicsImpostor(
      mesh,
      BABYLON.PhysicsImpostor.BoxImpostor,
      { mass, restitution, friction },
      mesh.getScene()
    );
  }
}
